export default __webpack_public_path__ + "media/images/front/municipality_collaboration/shizuoka/ogp-1dee4f43fb6d5f6b8641ced7c6bb5d69.jpg";